var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgPingpong = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  xmlns: "http://www.w3.org/2000/svg",
  width: 39.999,
  height: 39.999
}, props), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
  id: "pingpong_svg__a",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /* @__PURE__ */ React.createElement("stop", {
  offset: 0,
  stopColor: "#1e9ee6"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#3674c4"
}))), /* @__PURE__ */ React.createElement("path", {
  "data-name": "\\u77E9\\u5F62 3183",
  fill: "#fff",
  d: "M10.998.999h19v39h-19z"
}), /* @__PURE__ */ React.createElement("path", {
  "data-name": "\\u51CF\\u53BB 18",
  d: "M34 40H6a6.007 6.007 0 0 1-6-6V6a6.007 6.007 0 0 1 6-6h28a6.007 6.007 0 0 1 6 6v28a6.007 6.007 0 0 1-6 6ZM13.251 2.5v33.033a1.972 1.972 0 1 0 3.945 0v-8.3h3.344a6.627 6.627 0 0 0 6.637-6.628V9.138A6.644 6.644 0 0 0 20.54 2.5Zm7.042 20.861H17.2V6.411h3.1a3.061 3.061 0 0 1 3.062 3.054V20.31a3.061 3.061 0 0 1-3.069 3.053Z",
  transform: "translate(-.002 -.001)",
  fill: "url(#pingpong_svg__a)"
}));
export { SvgPingpong as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOS45OTkiIGhlaWdodD0iMzkuOTk5Ij48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIuNSIgeDI9Ii41IiB5Mj0iMSIgZ3JhZGllbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzFlOWVlNiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzM2NzRjNCIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxwYXRoIGRhdGEtbmFtZT0i55+p5b2iIDMxODMiIGZpbGw9IiNmZmYiIGQ9Ik0xMC45OTguOTk5aDE5djM5aC0xOXoiLz48cGF0aCBkYXRhLW5hbWU9IuWHj+WOuyAxOCIgZD0iTTM0IDQwSDZhNi4wMDcgNi4wMDcgMCAwIDEtNi02VjZhNi4wMDcgNi4wMDcgMCAwIDEgNi02aDI4YTYuMDA3IDYuMDA3IDAgMCAxIDYgNnYyOGE2LjAwNyA2LjAwNyAwIDAgMS02IDZaTTEzLjI1MSAyLjV2MzMuMDMzYTEuOTcyIDEuOTcyIDAgMSAwIDMuOTQ1IDB2LTguM2gzLjM0NGE2LjYyNyA2LjYyNyAwIDAgMCA2LjYzNy02LjYyOFY5LjEzOEE2LjY0NCA2LjY0NCAwIDAgMCAyMC41NCAyLjVabTcuMDQyIDIwLjg2MUgxNy4yVjYuNDExaDMuMWEzLjA2MSAzLjA2MSAwIDAgMSAzLjA2MiAzLjA1NFYyMC4zMWEzLjA2MSAzLjA2MSAwIDAgMS0zLjA2OSAzLjA1M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0uMDAyIC0uMDAxKSIgZmlsbD0idXJsKCNhKSIvPjwvc3ZnPg==";
